<template>
  <BListItem>
    <template #header>
      <div>{{ label }}</div>
    </template>
    <div
      v-if="isSelected"
      class="selected-content"
      @click="reset"
    >
      {{ currentSelect.name }}
    </div>
    <BInput
      v-else
      v-model="searchWord"
      :disabled="disabled"
      @keypress-enter="searchBySearchWord"
      @blur.self="resetItems"
    >
      <template #prefix>
        <BElementIcon
          :name="icon"
          type="gray"
        />
      </template>
    </BInput>
    <div
      ref="results"
      v-loading="isLoading"
      class="results"
      @scroll="loadMore"
    >
      <div
        v-for="(result, index) in dataRecords"
        :key="index"
        class="result-content"
        @mousedown="() => setId(result)"
      >
        <div class="result-item">
          <span>{{ result.name }}</span>
        </div>
      </div>
    </div>
  </BListItem>
</template>

<script>
export default {
  name: 'SalesforceReportSearchModel',
  props: {
    label: {
      type: String,
      required: true,
    },
    selectedId: {
      type: String,
      required: true,
    },
    selectedReport: {
      type: Object,
      required: true,
    },
    search: {
      type: Function,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'select-sf-report',
    'update:selectedReport',
    'update:selectedId',
  ],
  data (){
    return {
      searchWord: '',
      searchedItems: [],
      currentSelect: {},
      isLoading: false,
      icon: 'Search',
      currentPage: 1,
      perPage: 20,
      dataRecords: [],
    };
  },
  computed: {
    convertSearchedItems() {
      return this.searchedItems.map(sfData => ({ name: sfData.name, id: sfData.id }));
    },
    isSelected () {
      return Object.prototype.hasOwnProperty.call(this.currentSelect, 'id');
    },
    lastPage(){
      return Math.ceil(this.convertSearchedItems.length / this.perPage);
    },
  },
  watch: {
    disabled(newVal) {
      if (newVal == true) this.reset();
    },
    convertSearchedItems(newVal) {
      this.dataRecords = newVal.slice(0, this.perPage);
    },
    currentPage(newVal) {
      this.dataRecords = this.convertSearchedItems.slice(0, newVal * this.perPage);
    },
  },
  created() {
    this.setDefaultSearchedText();
  },
  methods: {
    async searchBySearchWord() {
      if (this.searchWord.length == 0) return;
      this.startLoading();
      this.searchedItems = [];
      this.currentPage = 1;
      this.searchedItems = await this.search(this.searchWord) || [];

      setTimeout(() => {
        this.endLoading();
      }, 300);

      if (this.searchedItems.length == 0) this.searchedItems = [{ name: this.$t('search.notFound', { text: this.searchWord }), id: 0 }];
    },
    setId(result){
      if (result.id == 0) return;
      this.currentSelect = result;
      this.$emit('select-sf-report', this.currentSelect.id);
      this.searchWord = this.currentSelect.name;
      this.$emit('update:selectedReport', result);
    },
    setDefaultSearchedText(){
      if (!Object.prototype.hasOwnProperty.call(this.selectedReport, 'id')) return;
      this.setId(this.selectedReport);
    },
    resetItems (){
      this.currentPage = 1;
      this.searchedItems = [];
      this.dataRecords= [];
    },
    reset(){
      this.currentSelect = {};
      this.searchWord = '';
      this.searchedItems = [];
      this.dataRecords= [];
      this.currentPage = 1;
      this.$emit('update:selectedId', '');
    },
    startLoading(){
      this.isLoading = true;
      this.icon = 'Loading';
    },
    endLoading() {
      this.isLoading = false;
      this.icon = 'Search';
    },
    loadMore(){
      const el = this.$refs.results;
      if (Math.floor(el.scrollHeight - el.scrollTop) === el.clientHeight && this.currentPage < this.lastPage)
        ++this.currentPage;
    },
  },
};
</script>

<style lang="scss" scoped>
.selected-content {
  width: 100%;
  padding: 9px 10px;
  border-radius: 5px;
  border: 1px solid #E3E3E3;
  &:hover {
    border: 1px solid $concrete;
  }
}
.results {
  padding: 0px 3px 0px 3px;
  overflow-y: scroll;
  cursor: pointer;
  max-height: 250px;
  -webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  .result-content {
    border-radius: 0px;
    padding-left: 15px;
    .result-item {
      padding: 10px 0px;
      position: relative;
      border-radius: 3px;
    }
  }
}
</style>
